import { CrudBuilderState } from "seneca-common/utils/apiStates";

import LocationsStateSlice from "../../models/LocationsStateSlice";
import { Locations } from "../../models/state/locations/Locations";

export function getLocationsSlice(state: LocationsStateSlice): Locations {
  return state.locations;
}

export function getMetaSlice(state: LocationsStateSlice): CrudBuilderState {
  return state.meta as CrudBuilderState;
}
